"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EOrigin;
(function (EOrigin) {
    EOrigin["PCC"] = "PCC";
    EOrigin["NCS"] = "NCS";
    EOrigin["MANUAL"] = "MANUAL";
})(EOrigin = exports.EOrigin || (exports.EOrigin = {}));
var EProcessActivityStatus;
(function (EProcessActivityStatus) {
    EProcessActivityStatus["PENDING"] = "PENDING";
    EProcessActivityStatus["SUCCESS"] = "SUCCESS";
    EProcessActivityStatus["ERROR"] = "ERROR";
    EProcessActivityStatus["SKIPPED"] = "SKIPPED";
})(EProcessActivityStatus = exports.EProcessActivityStatus || (exports.EProcessActivityStatus = {}));
var EProcessType;
(function (EProcessType) {
    EProcessType["FETCH_TRANSACTIONS"] = "FETCH_TRANSACTIONS";
    EProcessType["FETCH_RESIDENTS"] = "FETCH_RESIDENTS";
    EProcessType["GENERATE_STATEMENTS"] = "GENERATE_STATEMENTS";
    EProcessType["UPDATE_RESIDENTS_AND_TRANSACTIONS"] = "UPDATE_RESIDENTS_AND_TRANSACTIONS";
})(EProcessType = exports.EProcessType || (exports.EProcessType = {}));
var EProcessActivitySubscriptionType;
(function (EProcessActivitySubscriptionType) {
    EProcessActivitySubscriptionType["GENERATE_STATEMENTS"] = "GENERATE_STATEMENTS";
    EProcessActivitySubscriptionType["FETCH_TRANSACTIONS"] = "FETCH_TRANASCTIONS";
    EProcessActivitySubscriptionType["FETCH_TRANSACTIONS_AND_GENERATE_STATEMENTS"] = "FETCH_TRANSACTIONS_AND_GENERATE_STATEMENTS";
    EProcessActivitySubscriptionType["UPDATE_RESIDENTS_AND_TRANSACTIONS"] = "UPDATE_RESIDENTS_AND_TRANSACTIONS";
})(EProcessActivitySubscriptionType = exports.EProcessActivitySubscriptionType || (exports.EProcessActivitySubscriptionType = {}));
var ESortOrder;
(function (ESortOrder) {
    ESortOrder["ASC"] = "ASC";
    ESortOrder["DESC"] = "DESC";
})(ESortOrder = exports.ESortOrder || (exports.ESortOrder = {}));
